import React from 'react';
import { formatCount } from '../utils/dataTransformers';

interface PostStatsProps {
  likes: number;
  commentsCount: number;
}

const PostStats: React.FC<PostStatsProps> = ({ likes, commentsCount }) => {
  return (
    <div className="absolute bottom-5 right-2 flex flex-col items-end gap-2">
      <div className="flex flex-col items-center">
        <img
          src="/Group.svg"
          alt="likes icon"
          className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
        />
        <span className="text-xs text-white">
          {formatCount(likes) ?? 0}
        </span>
      </div>
      <div className="flex flex-col items-center">
        <img
          src="/Group (1).svg"
          alt="comments icon"
          className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
        />
        <span className="text-xs text-white">
          {formatCount(commentsCount) ?? 0}
        </span>
      </div>
      <div className="flex flex-col items-center">
        <img
          src="/Group (2).svg"
          alt="other icon"
          className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
        />
        <span className="text-xs text-white">--</span>
      </div>
    </div>
  );
};

export default PostStats;
